export const buildNavigationData = (intent) => ({
  ...intent,
  response_duration: null,
  timer_start: null,
  timer_stop: null,
  timer_expired: null
});
